import { useState } from 'react';
import { TbPhoto, TbSend } from 'react-icons/tb';
import { useAuth } from '../auth/AuthContext';
import { communityApi as defaultApi } from './community-api';
import { ProfileAvatarLink } from './PostCard';

export function PostComposer({ api = defaultApi, onPublished, disabled = false }) {
  const { user } = useAuth();
  const [body, setBody] = useState('');
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function submit(event) {
    event.preventDefault();
    if (busy || disabled || (!body.trim() && !files.length)) return;
    setBusy(true); setError('');
    try { await api.publish({ body: body.trim(), files }); setBody(''); setFiles([]); if (onPublished) onPublished(); }
    catch (caught) { setError(caught.message || 'No se pudo publicar.'); }
    finally { setBusy(false); }
  }
  return <form className="gym-form community-composer" onSubmit={submit}>
    <div className="community-composer__body">
      <ProfileAvatarLink person={user} className="community-composer__avatar" />
      <div className="gym-field community-composer__field">
        <label className="gym-field__label gym-sr-only" htmlFor="community-post-body">Compartí con la comunidad</label>
        <textarea className="gym-input" id="community-post-body" placeholder="Compartí con la comunidad" maxLength={2000} value={body} disabled={disabled} onChange={event => setBody(event.target.value)} />
      </div>
    </div>
    <div className="community-composer__meta"><span>Sé respetuoso. Las publicaciones pueden moderarse.</span><span>{body.length}/2000</span></div>
    {disabled && <p className="gym-state" role="status">Tu cuenta no puede participar en la comunidad.</p>}
    <div className="community-composer__actions">
      <input className="gym-input gym-sr-only community-composer__file-input" id="community-post-files" type="file" accept="image/*" multiple disabled={busy || disabled} aria-label="Agregar fotos" onChange={event => setFiles(Array.from(event.target.files || []).slice(0, 4))} />
      <label htmlFor="community-post-files" className="gym-button gym-button--secondary community-composer__file-trigger"><TbPhoto aria-hidden="true" focusable="false" />Agregar fotos</label>
      <button type="submit" className="gym-button gym-button--primary" disabled={busy || disabled || (!body.trim() && !files.length)}><TbSend aria-hidden="true" focusable="false" />{busy ? 'Publicando…' : 'Publicar'}</button>
    </div>
    {files.length > 0 && <p>{files.length} de 4 fotos seleccionadas</p>}
    {error && <p className="gym-form__error" role="alert">{error}</p>}
  </form>;
}
